import {useEffect, useState} from "react";
import valuer_api from "../../../api/valuer";


const ValuerAmendTableFreeText = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.section
    const identifier = props.identifier
    const rowIdentifier = props.rowIdentifier
    const columnIdentifier = props.columnIdentifier

    const [value, setValue] = useState('');
    const [rowValues, setRowValues] = useState({})

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Optional
    const textLimit = props.textLimit ? props.textLimit : false

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (props.rowValues !== undefined) setRowValues(props.rowValues);
    }, [props.rowValues])

    useEffect(() => {
        if (rowValues && rowValues[columnIdentifier] !== undefined) setValue(rowValues[columnIdentifier]);
    }, [rowValues, columnIdentifier])

    const UpdateValue = () => {
        if (rowValues === undefined) return
        let updateTime = Date.now()
        let table_identifier = `${identifier}-${columnIdentifier}-${rowIdentifier}`;
        let body = {
            "row": rowIdentifier,
            "value": value,
        }
        AddToQueue(section, table_identifier, updateTime)
        // Update parent with the new rows values
        let rv_copy = Object.assign({}, rowValues)
        rv_copy[columnIdentifier] = value
        UpdateParentValue(identifier, rv_copy, rowIdentifier)
        // Update DB
        let response = valuer_api.ValuerAmendPut(summaryId, identifier, columnIdentifier, body);
        response.then(
            response => {
                RemoveFromQueue(section, table_identifier, updateTime)
            }
        ).catch((err) => {
            AddToErroredSaves(section, table_identifier, updateTime)
            setErrorTitle("Failed to Save")
            setErrorMessage("The request to save a field within the table has failed")
        })
    }

    const ClickOff = () => {
        // Check for required fields and then submit change
        if (!summaryId || !section || !identifier || !rowIdentifier || !columnIdentifier) return
        UpdateValue()
    }

    return (
        <div className="valuer-amend-table-free-text-container">
            <input type={"text"} value={value} onChange={(ev) => {
                if (textLimit) {
                    if (ev.target.value.length > textLimit)
                        setValue(ev.target.value.substring(0, textLimit))
                    else setValue(ev.target.value)
                }
                else setValue(ev.target.value)}
            }
                   onBlur={() => ClickOff()}
            />
        </div>
    )
}

export default ValuerAmendTableFreeText;